import { Alert } from '@reach/alert';
import { rem, size, transparentize } from 'polished';
import styled, { css } from 'styled-components';

interface AlertProps {
  hasIcon?: boolean;
}

const alertSpacing = css`
  & + & {
    margin-top: ${rem(30)};
  }
`;

export const ReachAlertWrapper = styled(Alert)`
  ${alertSpacing};
`;

export const AlertStyled = styled.div<AlertProps>`
  display: flex;
  align-items: center;
  margin: 0;
  padding: ${rem(24)} ${rem(18)};
  color: ${({ theme }) => theme.colors.palette.black};
  line-height: 1.3;
  background-color: ${({ theme }) => theme.colors.palette.orange};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  gap: 12px;
  transition:
    box-shadow 150ms ease-in-out,
    background-color 150ms ease-in-out,
    color 150ms ease-in-out;

  ${alertSpacing};
`;

interface IconWrapperProps {
  center?: boolean;
  large?: boolean;
}

export const IconWrapper = styled.div<IconWrapperProps>`
  align-self: ${(props) => (props.center ? 'center' : 'flex-start')};
  margin-right: ${(props) => (props.large ? rem(14) : rem(16))};

  svg {
    vertical-align: middle;
    fill: ${({ theme }) => theme.colors.palette.black};
    ${({ large }) => size(large ? rem(40) : rem(26))};

    ${({ theme }) => theme.mediaQueries.medium} {
      ${({ large }) => size(large ? rem(40) : rem(24))};
    }
  }
`;

export const CopyWrapper = styled.div`
  flex-grow: 1;
`;

export const Link = styled.a`
  display: block;
  text-decoration: none;

  ${alertSpacing};

  ${AlertStyled} {
    margin: 0; /* Cancel the margin when inside a link */
  }

  &:hover ${AlertStyled} {
    background-color: ${({ theme }) => theme.colors.palette.orangeDark};
  }

  &:focus {
    outline: 0;

    ${AlertStyled} {
      box-shadow:
        inset 0 0 0 2px ${({ theme }) => theme.colors.palette.redDark},
        0 0 8px
          ${({ theme }) => transparentize(0.2, theme.colors.palette.redDark)};
    }
  }
`;

export const ChevronWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  margin: ${rem(-12)} ${rem(-10)} ${rem(-12)} 0;
  padding-left: ${rem(5)};
  border-left: 1px solid
    ${({ theme }) => transparentize(0.5, theme.colors.palette.black)};

  svg {
    width: ${rem(12)};
    height: ${rem(12)};
    vertical-align: middle;
  }
`;

export const Title = styled.strong`
  display: block;
  margin-bottom: ${rem(6)};

  ${({ theme }) => theme.mediaQueries.medium} {
    display: inline;
    padding-right: ${rem(6)};
    font-size: inherit;
  }
`;
